/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  ActionPlanDetailsDto,
  AnswerQuestionRequest,
  AnswerQuestionResponse,
  DiagnosisDetailsDto,
  DiagnosisScoreDto,
  GetDiagnosisDaoUrlsResponse,
  GetPriorityDiagnosesParams,
  HistoryDiagnosisDto,
  InProgressDiagnosisDto,
  PriorityDiagnosesResponseDto,
  StartDiagnosisRequest,
  StartDiagnosisResponse
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getDiagnoses = () => {
/**
 * Initiates a new diagnosis for the authenticated user based on the specified product family,
 * store, and team. If there is an existing in-progress diagnosis for the same family/team/store,
 * it returns that instead of creating a new one. The response includes the diagnosis ID and
 * the survey version to use for retrieving questions. Returns 400 if the request is invalid
 * or if the user is not authorized to diagnose in the specified store/team.
 * @summary Start a new diagnosis
 */
const startDiagnosis = (
    startDiagnosisRequest: StartDiagnosisRequest,
 ) => {
      return customInstance<StartDiagnosisResponse>(
      {url: `/api/v1/diagnoses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startDiagnosisRequest
    },
      );
    }
  /**
 * Returns all diagnoses that the authenticated user has started but not yet completed
 * for the specified store and team. Each diagnosis includes the family being diagnosed,
 * the start date, and the current completion percentage based on answered questions.
 * @summary Get in-progress diagnoses for a user in a store/team
 */
const getInProgressDiagnoses = (
    storeId: number,
    teamId: number,
 ) => {
      return customInstance<InProgressDiagnosisDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/diagnoses/in_progress`, method: 'GET'
    },
      );
    }
  /**
 * Returns the history of completed diagnoses for the authenticated user in the specified
 * store and team. Each entry includes the final compliance score, completion date, and
 * the product family that was diagnosed. Used to track past performance and compliance trends.
 * @summary Get diagnosis history for a user in a store/team
 */
const getDiagnosisHistories = (
    storeId: number,
    teamId: number,
 ) => {
      return customInstance<HistoryDiagnosisDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/diagnoses/histories`, method: 'GET'
    },
      );
    }
  /**
 * Returns priority diagnosis data for the specified period (week or month). Includes
 * the list of priority product families that require diagnosis, along with statistics
 * such as average compliance score, total families to diagnose, and completed diagnosis
 * count. Priority families are computed based on sales performance and compliance history.
 * @summary Get priority diagnoses for a store/team over a period
 */
const getPriorityDiagnoses = (
    storeId: number,
    teamId: number,
    params: GetPriorityDiagnosesParams,
 ) => {
      return customInstance<PriorityDiagnosesResponseDto>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/diagnoses/priorities`, method: 'GET',
        params
    },
      );
    }
  /**
 * Retrieves the full details of a diagnosis including its current status, the product
 * family being diagnosed, and the complete list of questions with their current answers.
 * Questions are returned in order and include labels, help text, and images in the
 * requested language. Used to display the diagnosis questionnaire to the vendor.
 * @summary Get diagnosis details (questions, status, family)
 */
const getDiagnosisDetails = (
    diagnosisId: string,
 ) => {
      return customInstance<DiagnosisDetailsDto>(
      {url: `/api/v1/diagnoses/${diagnosisId}/details`, method: 'GET'
    },
      );
    }
  /**
 * Records an answer (YES, NO, or NC - Not Concerned) for a specific question in a diagnosis.
 * When answering NO, the vendor can optionally include action IDs representing corrective
 * actions to add to their action plan. The response indicates whether the diagnosis is
 * now complete (all mandatory questions answered). Returns 403 if attempting to modify
 * a completed or closed diagnosis.
 * @summary Answer a question in a diagnosis
 */
const answerQuestion = (
    diagnosisId: string,
    questionId: string,
    answerQuestionRequest: AnswerQuestionRequest,
 ) => {
      return customInstance<AnswerQuestionResponse>(
      {url: `/api/v1/diagnoses/${diagnosisId}/questions/${questionId}/answers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: answerQuestionRequest
    },
      );
    }
  /**
 * Retrieves the final compliance score for a completed diagnosis. The score is calculated
 * as a percentage based on the ratio of positive answers (YES) to total applicable questions
 * (excluding NC answers). Also returns the product family information for display purposes.
 * @summary Get the score of a completed diagnosis
 */
const getDiagnosisScore = (
    diagnosisId: string,
 ) => {
      return customInstance<DiagnosisScoreDto>(
      {url: `/api/v1/diagnoses/${diagnosisId}/score`, method: 'GET'
    },
      );
    }
  /**
 * Retrieves the action plan associated with a diagnosis, if one exists. The action plan
 * contains all corrective actions that were selected during the diagnosis based on
 * negative answers. Includes the action plan status, individual action completion states,
 * the diagnosis score, and the product family context. Returns null for actionPlan if
 * no actions were created during the diagnosis.
 * @summary Get action plan details attached to a diagnosis
 */
const getDiagnosisActionPlan = (
    diagnosisId: string,
 ) => {
      return customInstance<ActionPlanDetailsDto>(
      {url: `/api/v1/diagnoses/${diagnosisId}/action-plan`, method: 'GET'
    },
      );
    }
  /**
 * Retrieves the DAO plan URL from the merch3d API for each gridHeight.
 * @summary Get DAO plans URLs for a diagnosis
 */
const getDiagnosisDaoUrls = (
    diagnosisId: string,
 ) => {
      return customInstance<GetDiagnosisDaoUrlsResponse>(
      {url: `/api/v1/diagnoses/${diagnosisId}/dao-urls`, method: 'GET'
    },
      );
    }
  return {startDiagnosis,getInProgressDiagnoses,getDiagnosisHistories,getPriorityDiagnoses,getDiagnosisDetails,answerQuestion,getDiagnosisScore,getDiagnosisActionPlan,getDiagnosisDaoUrls}};
export type StartDiagnosisResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['startDiagnosis']>>>
export type GetInProgressDiagnosesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getInProgressDiagnoses']>>>
export type GetDiagnosisHistoriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getDiagnosisHistories']>>>
export type GetPriorityDiagnosesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getPriorityDiagnoses']>>>
export type GetDiagnosisDetailsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getDiagnosisDetails']>>>
export type AnswerQuestionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['answerQuestion']>>>
export type GetDiagnosisScoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getDiagnosisScore']>>>
export type GetDiagnosisActionPlanResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getDiagnosisActionPlan']>>>
export type GetDiagnosisDaoUrlsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDiagnoses>['getDiagnosisDaoUrls']>>>
